// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialGithub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 12c0 4.375-2.8 8.075-6.7 9.425 0-.075.025-.15.025-.225v-2.277c0-1-.65-2.35-1.575-2.825 3.324-.35 4.9-2 4.9-4.25 0-.976-.4-1.925-1.101-2.7.25-.776.525-2.4-.075-3-1.5 0-2.4.974-2.625 1.224-.75-.25-1.55-.4-2.424-.4-.85 0-1.675.15-2.425.4-.225-.25-1.124-1.225-2.625-1.225-.625.625-.325 2.225-.1 3-.7.8-1.125 1.725-1.125 2.7 0 2.25 1.6 3.901 4.95 4.301-.576.3-1.05.924-1.326 1.625-.5.076-1.05.1-1.4.1-.75 0-.925-.125-1.325-.65-.4-.524-.824-.875-1.35-1.025-.274-.024-.474.176-.224.376.825.575.875 1.5 1.2 2.1.275.55.9.85 1.575.85H9.5v1.7c0 .175.025.35.075.476C5.225 20.6 2 16.7 2 12 2 6.475 6.475 2 12 2s10 4.475 10 10z"
    />
  </svg>
);
export default SvgSocialGithub;
